import * as React from 'react'
import cn from 'classnames'

import styles from './ProfileSkeleton.module.css'

const ProfileSkeleton: React.FC = () => (
  <div className={cn(styles.profileSkeleton, styles.loading)}>
    <div className={cn(styles.lineOne, styles.loading)} />
    <div className={cn(styles.lineTwo, styles.loading)} />
  </div>
)

export default ProfileSkeleton
